// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"91":"e4f03ddd","593":"e54fcf92","691":"8f2c0114","993":"3b435b1a"}[chunkId] + ".js";
};